
import { PROXY_ERROR_MESSAGE } from "../../../_proxy";
import { DATABASE } from "../../../database";
import { DataBaseEnum } from "../../../database/enum";
import { INTERNAL_API_V2_GET, INTERNAL_API_V2_PUT } from "../base";


export async function API_V2_USER_GET(ShowAlertView, fields = [], setStateLoader = null, bypassCache = false, complementData = false) {
    const url = `user?fields=${fields.join(',')}&complementData=${complementData}`;
    setStateLoader?.(true);

    const dataBase = DataBaseEnum.USER;
    const localBD = new DATABASE(dataBase.name)

    const bdItem = await localBD.getItemById(url);
    let response = null;
    if (!bdItem || bypassCache) {
        response = await INTERNAL_API_V2_GET(url);
        try { await localBD.insert(url, response) } catch (error) { }
    } else response = bdItem.content;

    if (!response) ShowAlertView?.(PROXY_ERROR_MESSAGE, () => { }, true);

    setStateLoader?.(false);
    return response
}
export async function API_V2_USER_PUT(ShowAlertView, fields = [], setStateLoader = null, json = null, bypassCache = false) {
    setStateLoader?.(true);
    const response = await INTERNAL_API_V2_PUT('user', !json
        ? { fields: fields.join('&') }
        : { fields: fields.join('&'), json }
    );
    if (!response)
        ShowAlertView?.(PROXY_ERROR_MESSAGE, () => { }, true);
    else {
        const dataBase = DataBaseEnum.USER;
        if (!bypassCache) {
            const localBD = new DATABASE(dataBase.name)
            requestAnimationFrame(async () => {
                await localBD.deleteDatabase();
            });
        }
    }

    setStateLoader?.(false);
    return response;
}
